import { AnswerModel } from './AnswerModel';
import { Instance, getRoot, types } from 'mobx-state-tree';
import { RangeModel } from './RangeModel';
import { StaticFrameModel } from './StaticFrameModel';

export const QuestionModel = types.model('QuestionModel', {
  _id: types.identifier,
  key: types.maybeNull(types.string),
  defaultNextKey: types.maybeNull(types.string),
  question: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  survey: types.maybeNull(types.string),
  feature: types.maybeNull(types.string),
  freeTextType: types.maybeNull(types.string),
  order: types.maybeNull(types.number),
  language: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  /** how the question is drawn: flowers, sleep_diary, mood_diary, journaling, regular */
  uiDesign: types.maybeNull(types.string),
  skippable: types.maybeNull(types.boolean),
  range: types.maybeNull(RangeModel),
  answersAreDynamic: types.boolean,
  answersDependOnSurveyResponses: types.boolean,
  nextQuestionDependsOnSurveyResponse: types.maybeNull(types.string),
  dynamicNextQuestionKeys: types.optional(types.array(types.string), []),
  jumpBackKeys: types.optional(types.array(types.string), []),
  answers: types.maybeNull(types.array(AnswerModel)),
  staticFrame: types.maybe(StaticFrameModel),
  disableStepBack: types.optional(types.boolean, false),
})
  .views(self => ({
    isReady(): boolean {
      const {question: qstore } = getRoot(self);
      return qstore.isReady(self._id);
    }
  }));


export interface IQuestionModel extends Instance<typeof QuestionModel> {}